// Copyright (c) 2016 Deere & Company

import Transfer, { getDefaultState as getTransferDefaultState } from './transfer';

const NewTransfer = Transfer;

export const getDefaultState = () => getTransferDefaultState();

export default NewTransfer;
